import { render } from "./ButtonWithConfirm.vue?vue&type=template&id=0d2f003e&scoped=true"
import script from "./ButtonWithConfirm.vue?vue&type=script&lang=js"
export * from "./ButtonWithConfirm.vue?vue&type=script&lang=js"

import "./ButtonWithConfirm.vue?vue&type=style&index=0&id=0d2f003e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2f003e"]])

export default __exports__